// providerslice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    "user_id": '',    
    "timezone": '',
    "ip_address":'',
    "action":'',
    "device_information":'',
    "value":'',
    "user_id_inverse": '',
    "timezone_inverse": '',
    "ip_address_inverse":'',
    "device_information_inverse":'',
    "value_inverse":'',
    'action_inverse':'',
    "match": false,
    "accessLogSearchApplied": false,

};

const accessLogSearchSlice = createSlice({
    name: 'accessLogSearch',
    initialState,
    reducers: {
        setAccessLogSearch(state, action) {
            return { ...state, ...action.payload };
        },
        resetAccessLogSearch(state) {
            return { ...initialState, accessLogSearchApplied: false }; // Reset state and flag
        },
        setAccessLogSearchApplied(state) {
            state.accessLogSearchApplied = true; // Directly set searchApplied to true
        },
    },
});

export const { setAccessLogSearch, resetAccessLogSearch, setAccessLogSearchApplied } = accessLogSearchSlice.actions;

export default accessLogSearchSlice.reducer;